import { IconBase, IconComponent } from './BaseIcon';

export const AlignJustify: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M2 2.04h28v2H2zM2 8.54h28v2H2zM2 15.04h28v2H2zM2 28.04h28v2H2zM2 21.54h28v2H2z" />
  </IconBase>
);
